import DeleteApiKeyRequestModelBase from '../_generated/modelBases/delete-api-key-request-model-base';

export default class DeleteApiKeyRequestModel extends DeleteApiKeyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
